import React, {useEffect, useState} from 'react';
import styles from './PersonNotes.module.css';
import {NoteApi, NoteShort} from "../../../api/NoteApi.ts";
import {getUserFriendlyErrorMessage} from "@/utils/errorHandling.ts";
import {getNoteTableColumns} from "./noteTable.tsx";
import {ApiError} from "@/services/api";
import {
  Button,
  EmptyState,
  ErrorHappened,
  Loading,
  ModalSize,
  SorterResult,
  Table,
  useModal
} from "@fs/uikit-react";
import NoteModal
  from "@/pages/Operator/Person/components/edit/PersonNotes/modals/NoteModal/NoteModal.tsx";

interface PersonNotesProps {
  personId?: string;
}

const PersonNotes: React.FC<PersonNotesProps> = ({personId}) => {

  const {openModal} = useModal();

  const [notes, setNotes] = useState<NoteShort[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<ApiError | null>(null);
  const [sorters, setSorters] = useState<SorterResult[]>([
    {columnKey: 'modifiedAt', order: 'descend'}
  ]);

  const fetchNotes = async () => {
    if (!personId) return;
    try {
      setIsLoading(true);
      setError(null);
      const response = await NoteApi.getByPersonId(personId);
      setNotes(response.data);
    } catch (err) {
      setError(err as ApiError);
      console.error('Error fetching notes:', err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchNotes();
  }, [personId]);

  const handleCreateNote = () => {
    if (!personId)
      return;

    openModal(
      ModalSize.FULLSCREEN,
      'Створити нотатку',
      <NoteModal personId={personId} onSuccess={fetchNotes} />
    );
  };

  const handleEditNote = (note: NoteShort) => {
    if (!personId || !note.id)
      return;

    openModal(
      ModalSize.FULLSCREEN,
      'Редагувати нотатку',
      <NoteModal personId={personId} noteId={note.id} onSuccess={fetchNotes} />
    );
  };

  if (isLoading) {
    return <Loading text="Загружаємо нотатки..."/>;
  }

  if (error) {
    return <ErrorHappened text={getUserFriendlyErrorMessage(error)}/>;
  }

  return (
    <div className={styles.container}>
      <div className={styles.actions}>
        <Button title="Створити" onClick={handleCreateNote} />
      </div>
      {!notes || notes.length === 0 ? (
        <EmptyState text="Немає доступних нотаток" />
      ) : (
        <Table
          data={notes}
          columns={getNoteTableColumns()}
          onSort={setSorters}
          initialSorters={sorters}
          onClick={handleEditNote}
        />
      )}
    </div>
  );
};

export default PersonNotes;
